import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import CssBaseline from "@mui/material/CssBaseline";
 
import { BrowserRouter } from "react-router-dom";
import AuthContextProvider from "./Auth/components/AuthContext";

import { Provider } from "react-redux";
import { store } from "./shared/store/store";
import { HelmetProvider } from 'react-helmet-async';
// contexts
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
const root = ReactDOM.createRoot(document.getElementById("root"));
let persistor = persistStore(store);

root.render(

//  <React.StrictMode>
   
      <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
    <HelmetProvider>
    <SettingsProvider>
   
    <BrowserRouter>
      <CollapseDrawerProvider>
     
      <AuthContextProvider>
          <App />
          </AuthContextProvider>
  
      </CollapseDrawerProvider>
      </BrowserRouter>
     
    </SettingsProvider>
  </HelmetProvider>
  </PersistGate>
  </Provider>
  //  </React.StrictMode>
 
);


